import SectionWrapper from "../components/SectionWrapper";
import StatCard from "../components/StatCard";
import { AnimatedHeading } from "../components/AnimatedText";

const Stats = () => {
  const stats = [
    { number: 2000*96, suffix: "+", label: "Notifications batched every day" },
    { number: 2000, suffix: "+", label: "Users calm, focused, & productive" },
    { number: 45, suffix: "+", label: "Minutes saved per day" }
  ];

  return (
    <SectionWrapper background="dark" padding="md">
      <div className="text-center mb-12">
        <AnimatedHeading 
          as="h2" 
          className="text-3xl md:text-4xl mb-4"
        >
          Empowering focused productivity for a distraction-free experience.
        </AnimatedHeading>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {stats.map((stat, index) => (
          <StatCard
            key={index}
            number={stat.number}
            suffix={stat.suffix}
            label={stat.label}
            delay={index}
          />
        ))}
      </div>
    </SectionWrapper>
  );
};

export default Stats;
